//JS LIBRARIES
global.Modal = require('bootstrap/js/dist/modal');
global.Collapse = require('bootstrap/js/dist/collapse');
global.Offcanvas = require('bootstrap/js/dist/offcanvas');
global.Carousel = require('bootstrap/js/dist/carousel');
const LazyLoad = require("vanilla-lazyload");
global.lazyLoad = new LazyLoad();
require('../../scripts-optimized/lazy-loading-polyfill');
require('../../scripts/Tools/webp-polyfill');
require('../../scripts-optimized/polyfills');

//JS
require('../../scripts-optimized/Whatsapp/main-critic');
require('../../scripts-optimized/MessageSOS/main-critic');
require('../../scripts-optimized/HelpWidget/main-critic');
require('../../scripts-optimized/Cookies/main-critic');
require('../../scripts-optimized/Newsletter/main-critic');
require('../../scripts-optimized/Country/Popup/main-critic');
require('../../scripts-optimized/PopupSmarterClick/main-critic');
require('../../scripts-optimized/Header/Messages/main-critic');
require('../../scripts-optimized/Header/SearcherV2/main-critic');
require('../../scripts-optimized/Header/LeftMenu/main-critic');
require('../../scripts-optimized/Header/Login/main-critic');
require('../../scripts-optimized/Header/Cart/main-critic');
require('../../scripts-optimized/Header/OuterMenu/main-critic');
require('../../scripts-optimized/Header/Breadcrumb/main-critic');
require('../../scripts-optimized/LeftMenu/main-critic');
require('../../scripts-optimized/LeftMenuV2/main-critic');
require('../../scripts-optimized/Product/Size/main-critic');
require('../../scripts-optimized/Product/Color/main-critic');
require('../../scripts-optimized/Product/Pack/main-critic');
require('../../scripts-optimized/Product/CustomText/main-critic');
require('../../scripts-optimized/Product/CustomImage/main-critic');
require('../../scripts-optimized/Product/GlassReversed/main-critic');
require('../../scripts-optimized/Product/Tissue/main-critic');
require('../../scripts-optimized/Product/TissueDrop/main-critic');
require('../../scripts-optimized/Product/ChainPosition/main-critic');
require('../../scripts-optimized/Product/SupportColor/main-critic');
require('../../scripts-optimized/Product/ModelGender/main-critic');
require('../../scripts-optimized/Product/Model/main-critic');
require('../../scripts-optimized/Product/ModelSize/main-critic');
require('../../scripts-optimized/Product/MaterialColor/main-critic');
require('../../scripts-optimized/Product/Complement/main-critic');
require('../../scripts-optimized/Tools/Textarea/main-critic');
require('../../scripts-optimized/Tools/ScrollTopButton/main-critic');
require('../../scripts-optimized/Tools/PopupImageZoom/main-critic');
require('../../scripts-optimized/Wishlist/main-critic');
require('../../scripts-optimized/Tools/PopupReviewImageZoom/main-critic');


require('../../scripts-optimized/ProductPage/General/main-critic');
require('../../scripts-optimized/ProductPage/Reviews/main-critic');
require('../../scripts-optimized/ProductPage/PopupPersonalizedText/main-critic');
require('../../scripts-optimized/ProductPage/ImageZoom/main-critic');
require('../../scripts-optimized/ProductPage/ArTool/main-critic');
require('../../scripts-optimized/ProductPage/ReviewImages/main-critic');


require('../../scripts-optimized/Footer/Contact/main-critic');
require('../../scripts-optimized/Footer/Newsletter/main-critic');
require('../../scripts-optimized/Footer/Social/main-critic');


//CSS
require('../../../../sass/website/Optimized/Libraries/ProductPage/Blind/bootstrap.min.css');
require('@fortawesome/fontawesome-free/css/solid.min.css');
require('@fortawesome/fontawesome-free/css/regular.min.css');
require('@fortawesome/fontawesome-free/css/brands.min.css');
require('../../../../sass/website/Optimized/Libraries/ProductPage/Blind/fontawesome.min.css');
require('../../../../sass/website/Optimized/General/main-critic.scss');
require('../../../../sass/website/Optimized/Newsletter/Popup/main-critic.scss');
require('../../../../sass/website/Optimized/Cookies/Popup/main-critic.scss');
require('../../../../sass/website/Optimized/Country/Popup/main-critic.scss');
require('../../../../sass/website/Optimized/SmarterClick/Popup/main-critic.scss');
require('../../../../sass/website/Optimized/Header/General/main-critic.scss');
require('../../../../sass/website/Optimized/ProductPage/General/main-critic.scss');
require('../../../../sass/website/Optimized/ProductPage/Options/Sizes/Blind/main-critic.scss');
require('../../../../sass/website/Optimized/ProductPage/Options/Tissue/Selectable/main-critic.scss');
require('../../../../sass/website/Optimized/ProductPage/Options/TissueDrop/Selectable/main-critic.scss');
require('../../../../sass/website/Optimized/ProductPage/Options/ChainPosition/Selectable/main-critic.scss');
require('../../../../sass/website/Optimized/ProductPage/Options/SupportColor/Selectable/main-critic.scss');
require('../../../../sass/website/Optimized/ProductPage/Options/Customizer/Selectable/main-critic.scss');
require('../../../../sass/website/Optimized/ProductPage/UpSellingPersonalizedText/main-critic.scss');
require('../../../../sass/website/Optimized/Footer/General/main-critic.scss');
require('../../../../sass/website/Optimized/ProductPage/Reviews/ReviewImages/main-critic.scss');